import {Component, Injector, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {Router} from '@angular/router';
import {SnackBarService} from '../../services/snack-bar.service';
import {PomodoroRepository} from '../../Models/PomodoroRepository';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {
  public password = {
    password: '',
    password_confirmation: '',
  };
  public pomodoroRepository: PomodoroRepository;
  public error: any;
  public registerSpinner = false;

  constructor(private userService: UserService,
              private router: Router,
              private snackBar: SnackBarService,
              private injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
  }

  redirectToProfile(): any {
    this.router.navigateByUrl('/profile').then(() => {
      location.reload();
    });
  }

  setPassword(): any {
    this.registerSpinner = true;
    if (!this.password.password || !this.password.password_confirmation){
      this.snackBar.showSnackBar('پر کردن تمامی فیلدها الزامی است.', 'red-snackbar');
      this.registerSpinner = false;
      return;
    } else{
      this.userService.setPassword(this.password).subscribe(
        (data) => {
          // localStorage.setItem('token', data);
          if (localStorage.getItem('trans') === 'fa'){
            this.snackBar.showSnackBar( 'رمز عبور با موفقیت تعیین شد.', 'green-snackbar');
          } else if (localStorage.getItem('trans') === 'en'){
            this.snackBar.showSnackBar( 'The password has been chosen successfully.', 'green-snackbar');
          }
          this.userService.getCurrentUserInfo().subscribe((dd) => {
            localStorage.setItem('userId', dd.id);
            localStorage.setItem('userProfile', dd.profile_photo_url);
          });
          this.registerSpinner = false;
          this.redirectToProfile();
        },
        (err) => {
          this.error = JSON.parse(err.error);
          if (this.pomodoroRepository.ltrDirection === true){
            // tslint:disable-next-line:forin
            for (const i in this.error) {
              const child = this.error[i];
              this.snackBar.showSnackBar( child[0], 'ltr-snackbar');
              break;
            }
          }
          if (this.pomodoroRepository.ltrDirection === false){
            // tslint:disable-next-line:forin
            for (const i in this.error) {
              const child = this.error[i];
              this.snackBar.showSnackBar( child[0], 'red-snackbar');
              break;
            }
          }
          this.registerSpinner = false;
        }
      );
    }
  }
}
